var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5156 10.5156L13.0156 18.7656C12.875 18.9531 12.6875 19 12.5 19C12.3125 19 12.125 18.9531 11.9844 18.8125C11.6562 18.5312 11.6562 18.0625 11.9375 17.7812L18.2656 10.75H1.25C0.828125 10.75 0.5 10.4219 0.5 10.0469C0.5 9.67188 0.828125 9.25 1.25 9.25H18.2656L11.9375 2.26562C11.6562 1.98438 11.6562 1.51562 11.9844 1.23438C12.2656 0.953125 12.7344 0.953125 13.0156 1.28125L20.5156 9.53125C20.7969 9.8125 20.7969 10.2344 20.5156 10.5156Z",
    fill: "#FF6C2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3e7005500f5188ccd8d34e5167a2cfbe.svg";
export { ForwardRef as ReactComponent };